import type {CopilotUIMessage} from '@mixpanel/ai-copilot/agent/types';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import {getProjectId, getWorkspaceId} from 'common/report/util';

// URL param that pins a copilot session to a specific conversation id —
// read on layout mount to open that chat, written by spark report/board
// click handlers when deep-linking from a notification, and skipped by the
// session-context restore-on-refresh effect so the two flows don't race.
export const COPILOT_CONVERSATION_PARAM = `copilot_conversation`;

export function getCopyableTextFromMessage(message: CopilotUIMessage): string {
  return message.parts
    .map((part) => {
      if (part.type === `text`) {
        return part.text.trim();
      }
      // TODO: Add support for other message part types.
      return ``;
    })
    .filter(Boolean)
    .join(`\n`);
}

export function getCopilotURLParams() {
  const dict = omitBy(
    {
      project_id: getProjectId() || undefined,
      workspace_id: getWorkspaceId() || undefined,
    },
    isNil,
  );

  const urlParams = new URLSearchParams(dict as Record<string, string>);

  return urlParams.toString();
}
